import axios from 'axios'

var toStr = Object.prototype.toString
const rangy = require('rangy')

axios.defaults.baseURL = process.env.VUE_APP_API_URL || ''
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

var hj = {}

hj.json = (function() {
	return {
		parse: function(a) {
			return (JSON.parse || JSON.decode)(a)
		},
		tryParse: function(a, b) {
			var c = !0,
				d
			try {
				d = (JSON.parse || JSON.decode)(a)
				b && b(d)
			} catch (e) {
				c = !1
			}
			return c
		},
		stringify: function(a, b, c) {
			var d, e
			if (void 0 !== a) {
				return (
					(d = Array.prototype.toJSON),
					delete Array.prototype.toJSON,
					(e = JSON.stringify || JSON.encode),
					(a = (e('\u2028') === '"\u2028"'
						? function(a, b, c) {
								return e(a, b, c).replace(/\u2028|\u2029/g, function(a) {
									return '\\u202' + (a === '\u2028' ? '8' : '9')
								})
						  }
						: e)(a, b, c)),
					d && (Array.prototype.toJSON = d),
					a
				)
			}
		},
	}
})()

function onMessage(callback) {
	window.addEventListener
		? window.addEventListener('message', callback, !1)
		: window.attachEvent('onmessage', callback)
}

var cookie = (function() {
	return {
		getCookie: function(a) {
			return a ? ((a = RegExp('(?:^|; )' + a + '=([^;]*)').exec(document.cookie)) ? a[1] : void 0) : void 0
		},
		setCookie: function(a, b, c) {
			if (a) {
				var d = new Date()
				d.setDate(d.getDate() + c)
				document.cookie = a + '=' + b + '; path=/; expires=' + d.toUTCString()
			}
		},
	}
})()

function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (Math.random() * 16) | 0,
			v = c == 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
}

function scrollMeTo(element) {
	if (!element) return

	const top = element.offsetTop

	window.scrollTo(0, top)
}

function loadSdkAsynchronously(src, id, cb) {
	return (function(__dom, __tag, __id, __callback) {
		if (__dom.getElementById(__id)) return
		var __fjs = __dom.getElementsByTagName(__tag)[0],
			__cjs = __dom.createElement(__tag)
		__cjs.id = __id
		__cjs.src = src
		__cjs.onload = function() {
			__callback ? __callback(__cjs) : void 0
		}
		__fjs.parentNode.insertBefore(__cjs, __fjs)
	})(document, 'script', id, cb)
}

function removeWedgitMessenger(id = 'web__messenger--test') {
	var _element = document.getElementById(id)
	var _widget = document.getElementsByClassName('hansa-widget-area')
	if (_widget.length) {
		_widget[0].remove()
	}
	_element && _element.remove()
}

function loadMessenger(scriptCode, callbackDone, callbackError) {
	var id = 'web__messenger--test'
	var oldScript = document.getElementById(id)
	if (oldScript) {
		if (is_fun(callbackDone)) {
			return callbackDone({script: oldScript})
		}
		// removeWedgitMessenger(id)
	}

	try {
		var fragmentScript = document.createElement('div')
		fragmentScript.innerHTML = scriptCode
		var src = fragmentScript.firstElementChild.src
		if (src) {
			fragmentScript = null
			src += '&id=' + Date.now()
			console.log('src', src)
			loadSdkAsynchronously(src, id, function(script) {
				script.setAttribute('loaded', 1)
				if (is_fun(callbackDone)) {
					callbackDone({script: script})
				}
			})
		}
	} catch (e) {
		if (is_fun(callbackError)) {
			callbackError(e)
		}
	}
}

function randomID() {
	return parseInt(String(Date.now()) + ((Math.random() * (999999 - 1) + 1) | (0 & 0x3) | 0x8))
}

const randomStr = (length = 16) => {
	let result = ''
	let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let charactersLength = characters.length
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
	}
	return result
}

const randomInt = (length = 16) => {
	let result = ''
	let characters = '0123456789'
	let charactersLength = characters.length
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
	}
	return result
}

function getParams(url) {
	url = url || window.location.href
	var vars = {}

	url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
		vars[key] = value
	})
	return vars
}

function getSelectionText() {
	var text = ''
	var activeEl = document.activeElement
	var activeElTagName = activeEl ? activeEl.tagName.toLowerCase() : null
	if (
		activeElTagName == 'textarea' ||
		(activeElTagName == 'input' &&
			/^(?:text|search|password|tel|url)$/i.test(activeEl.type) &&
			typeof activeEl.selectionStart === 'number')
	) {
		text = activeEl.value.slice(activeEl.selectionStart, activeEl.selectionEnd)
		// this.textSelection = text
		return text
	}
}

function dump() {
	if (window && window.hasOwnProperty('console') && process.env.NODE_ENV != 'production') {
		return console.log(...arguments)
	}
}

function copyToClipboard(text) {
	function fallbackCopyTextToClipboard() {
		var textArea = document.createElement('textarea')
		textArea.value = text
		document.body.appendChild(textArea)
		textArea.focus()
		textArea.select()
		try {
			document.execCommand('copy')
		} catch (err) {
			//
		}
		document.body.removeChild(textArea)
	}

	function copyTextToClipboard() {
		if (!navigator.clipboard) {
			fallbackCopyTextToClipboard()
			return
		}
		navigator.clipboard.writeText(text)
	}
	return copyTextToClipboard()
}

function is_fun(fn) {
	return toStr.call(fn) === '[object Function]'
}

function is_null(value) {
	return toStr.call(value) === '[object Null]'
}

function is_obj(value) {
	return toStr.call(value) === '[object Object]'
}

function is_arr(value) {
	return value && toStr.call(value) === '[object Array]'
}

function is_str(value) {
	return toStr.call(value) === '[object String]'
}

function is_num(value) {
	var _value = Number(value)
	return !!(!isNaN(_value) && !!String(value).trim().length && toStr.call(_value) === '[object Number]')
}

function is_url(value) {
	var $pattern = new RegExp(
		'^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
			'(\\#[-a-z\\d_]*)?$',
		'i'
	) // fragment locator
	return $pattern.test(value)
}

function is_base_64(str) {
	const pattern = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i
	return !!str.match(pattern)
}

function clone(value) {
	if (is_obj(value)) {
		return hj.json.parse(hj.json.stringify(value))
	} else if (is_arr(value) || is_str(value)) {
		return value.slice()
	} else if (is_num(value)) {
		return 0 + new Number(value)
	}
	return value
}

function getDefaultAutoCompleteSpanStyle(key) {
	var defaultStyles = {
		'@f': {
			backColor: '#000000',
			color: '#fff',
		},
		'@d': {
			backColor: '#0765c3',
			color: '#fff',
		},
		'@v': {
			backColor: '#a8a9bd',
			color: '#fff',
		},
		'@m': {
			backColor: '#20c997',
			color: '#fff',
		},
	}
	if (defaultStyles.hasOwnProperty(key)) return defaultStyles[key]
	return defaultStyles['@f']
}

// ------- autoCompleteTextToHTML
function autoCompleteTextToHTML(str, modules, html) {
	if ('make request m%title' == str) {
		// console.log(modules);
	}

	// return html;

	var keyword, isFunc, isD, isVar, isMenu, curruntModule, text, data, style, span

	if (!Array.isArray(str)) {
		if (is_str(str) && str.length) {
			return autoCompleteTextToHTML.apply(this, [str.split(/(\s+)/), modules, ''])
		}
		return ''
	}

	if (!str.length) {
		if (this && typeof this.innerHTML !== 'undefined') {
			this.innerHTML = html
		}
		// console.log(html, modules)
		return html
	}

	keyword = '' + str.splice(0, 1)
	isFunc = keyword.startsWith('f%')
	isD = keyword.startsWith('d%')
	isVar = keyword.startsWith('v%')
	isMenu = keyword.startsWith('m%')
	if (isFunc || isD || isVar || isMenu) {
		if (isFunc) {
			curruntModule = modules['@f']
		}
		if (isD) {
			curruntModule = modules['@d']
		}
		if (isVar) {
			curruntModule = modules['@v']
		}

		if (isMenu) {
			curruntModule = modules['@m']
		}
		if (curruntModule) {
			curruntModule.style =
				curruntModule.style ||
				getDefaultAutoCompleteSpanStyle(isFunc ? '@f' : isD ? '@d' : isVar ? '@v' : isMenu ? '@m' : '')

			text = keyword.slice()
			text = text
				.replace(/f%/, '')
				.replace(/d%/, '')
				.replace(/v%/, '')
				.replace(/m%/, '')

			data = curruntModule.list
			style = curruntModule.style
			span = ''
			for (var i = 0; i < text.length; ++i) {
				span += text[i]
				var prop = isFunc ? 'f' : isD ? 'd' : isVar ? 'v' : isMenu ? 'm' : ''
				if (data.indexOf(span) >= 0) {
					html += `<span style="
                        background-color:${style.backColor};
                        color:${style.color};
                        padding: .09rem .5rem;
                        border-radius: .9rem;
                        box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
                        margin: 0 .2rem;
                        font-size: 90%;
                        "
                        target="${prop}"
                        contenteditable="false">${span}</span>
                    `
					span = ''
				}
			}
			html += span
		}
	} else {
		html += keyword
	}
	return autoCompleteTextToHTML.apply(this, [str, modules, html])
}

function addEvent(element, eventName, func) {
	if (element.addEventListener) {
		element.addEventListener(eventName, func, false)
	} else if (element.attachEvent) {
		element.attachEvent('on' + eventName, func)
	} else {
		element['on' + eventName] = func
	}
}

function removeEvent(element, eventName, func) {
	if (element) {
		if (element.removeEventListener) {
			element.removeEventListener(eventName, func, false)
		} else if (element.detachEvent) {
			element.detachEvent('on' + eventName, func)
		} else {
			element['on' + eventName] = null
		}
	}
}

function preventDefaultEvent(e) {
	if (e.preventDefault) {
		e.preventDefault()
	} else {
		e.returnValue = false
	}
}

function isEventSupported(element, eventName) {
	eventName = 'on' + eventName
	var el = document.createElement(element.tagName),
		isSupported = eventName in el
	if (!isSupported) {
		el.setAttribute(eventName, 'return;')
		isSupported = typeof el[eventName] == 'function'
	}
	el = null
	return isSupported
}

function hasChildElement(elm) {
	var child, rv

	if (elm.children) {
		// Supports `children`
		rv = elm.children.length !== 0
	} else {
		// The hard way...
		rv = false
		for (child = elm.firstChild; !rv && child; child = child.nextSibling) {
			if (child.nodeType == 1) {
				// 1 == Element
				rv = true
			}
		}
	}
	return rv
}

function deepExtend(destination, source) {
	var property, propertyValue

	for (property in source)
		if (source.hasOwnProperty(property)) {
			propertyValue = source[property]
			if (
				propertyValue !== undefined &&
				propertyValue !== null &&
				propertyValue.constructor !== undefined &&
				propertyValue.constructor === Object
			) {
				destination[property] = destination[property] || {}
				deepExtend(destination[property], propertyValue)
			} else {
				destination[property] = propertyValue
			}
		}
	return destination
}

function uniqueId(prefix = '') {
	return (
		(prefix.length ? prefix + '-' : prefix) +
		Math.random()
			.toString(36)
			.substr(2, 9)
	)
}

function redirect_to(url, timeout = 0) {
	var path = url.match(/^https?:\/\//i) ? url : process.env.VUE_APP_SERVER_URL + url
	setTimeout(function() {
		window.location.href = path
	}, timeout)
}

function addXMLRequestCallback(callback) {
	var oldSend, i, res
	if (XMLHttpRequest.callbacks) {
		XMLHttpRequest.callbacks.push(callback)
	} else {
		XMLHttpRequest.callbacks = [callback]
		oldSend = XMLHttpRequest.prototype.send
		XMLHttpRequest.prototype.send = function() {
			var oldOnreadystatechange = this.onreadystatechange
			oldSend.apply(this, arguments)

			this.onreadystatechange = function() {
				oldOnreadystatechange()
				if (this.readyState !== 4) {
					return
				}
				try {
					res = JSON.parse(this.responseText)
					for (i = 0; i < XMLHttpRequest.callbacks.length; i++) {
						XMLHttpRequest.callbacks[i](res)
					}
				} catch (e) {
					//
				}
			}
		}
	}
}

function cleanObject(obj) {
	var x = clone(obj)
	x = Object.keys(x).reduce(function(a, b) {
		if (x[b] && x[b].length) {
			return {
				...a,
				[b]: x[b],
			}
		}
		return a
	}, {})
	return x
}

var id = function() {
	// Math.random should be unique because of its seeding algorithm.
	// Convert it to base 36 (numbers + letters), and grab the first 9 characters
	// after the decimal.
	return (
		'_' +
		Math.random()
			.toString(36)
			.substr(2, 9)
	)
}

const PARSER_VERSION = 2
const ENAPLE_LOG = !true

window.PARSER_VERSION = PARSER_VERSION
window.ENAPLE_LOG = ENAPLE_LOG

window.current_params = {}
window.warning_msg = ''
window.is_login = false

window.rangy = rangy
window.onMessage = onMessage
window.hj = hj
window.cookie = cookie
window.uuidv4 = uuidv4
window.loadSdkAsynchronously = loadSdkAsynchronously
window.removeWedgitMessenger = removeWedgitMessenger
window.loadMessenger = loadMessenger
window.randomID = randomID
window.getUrlParams = getParams
window.getSelectionText = getSelectionText
window.copyToClipboard = copyToClipboard
window.dump = dump
window.is_fun = is_fun
window.is_func = is_fun
window.is_str = is_str
window.is_arr = is_arr
window.is_null = is_null
window.is_obj = is_obj
window.is_num = is_num
window.is_url = is_url
window.is_base_64 = is_base_64
window.clone = clone
window.getDefaultAutoCompleteSpanStyle = getDefaultAutoCompleteSpanStyle
window.autoCompleteTextToHTML = autoCompleteTextToHTML
window.addEvent = addEvent
window.removeEvent = removeEvent
window.isEventSupported = isEventSupported
window.preventDefaultEvent = preventDefaultEvent
window.hasChildElement = hasChildElement
window.toStr = toStr
window.deepExtend = deepExtend
window.uniqueId = uniqueId
window.redirect_to = redirect_to
window.addXMLRequestCallback = addXMLRequestCallback
window.randomStr = randomStr
window.randomInt = randomInt
window.cleanObject = cleanObject
window.scrollMeTo = scrollMeTo
window.id = id
